import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useWidgetSelector } from '../core/hooks';

import _ from 'lodash';
import cx from 'classnames';

import styles from './form.module.scss';


const FormStepWidget = ({ className, style, widgetProps, breakpoint, children }) => {
  const id = _.get(widgetProps, 'uid');
  const type = _.get(widgetProps, 'type');

  const properties = _.get(widgetProps, 'properties', {});
  const parentWidget = useWidgetSelector(widgetProps.parent);
  
  const width = _.get(parentWidget, `properties.${breakpoint}.layout.width`) || 'auto';
  const height = _.get(parentWidget, `properties.${breakpoint}.layout.height`)  || 'auto';

  const widgetStyles = {
    ...style,
    width: width,
    height: height
  };

  return (
    <div id={id}
      className={cx(className, styles.formStep)}
      style={widgetStyles}
      data-widget-id={id}
      data-widget-type={type}
    >
      {children}
    </div>
  );
};

export { FormStepWidget };
